import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-blocker',
  templateUrl: './mobile-blocker.component.html',
  styleUrls: ['./mobile-blocker.component.scss'],
  standalone: true
})
export class MobileBlockerComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
